





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ProductTypeEnum } from '@/api/types';
import { list_product_summaries, listProductSummaries } from '@/api/product';
import { look_up_ticket_number } from '@/api/ticket';
import { AppModule } from '@/store/modules/app';
import { formatApiError } from '@/utils/index';
import { productById } from '@/utils/product';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'TicketSearchForm',
})
export default class TicketSearchForm extends Vue {
  public static readonly ticketSearchFormSearchEvent =
    'ticket-search-form-search';

  private productItems: ItemType[] = [];
  private products: Map<string, list_product_summaries.Product> = new Map();
  private openPanels = [0];
  private valid = false;
  private productId = '';
  private productIdRules: ((v: string) => boolean | string)[] = [];
  private ticketNumber = '';
  private ticketNumberRules: ((v: string) => boolean | string)[] = [];

  get appLanguage() {
    return AppModule.language;
  }

  get ticketTypeText() {
    return this.products.has(this.productId)
      ? this.products.get(this.productId)!.name
      : '';
  }

  created() {
    this.productIdRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Ticket type'),
        }) as string),
    ];
    this.ticketNumberRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Ticket number'),
        }) as string),
    ];
  }

  mounted() {
    this.fetchData();
  }

  @Watch('appLanguage')
  private onLangSelected() {
    this.loadProductItems();
    (this.$refs.form as any).resetValidation();
  }

  private async fetchData() {
    AppModule.StartProgress();
    try {
      const listProductsRes = await listProductSummaries({
        types: Object.values(ProductTypeEnum).filter(
          t => (t as ProductTypeEnum) === ProductTypeEnum.REAL_TICKET
        ),
        includeInactive: false,
      } as list_product_summaries.Request);
      this.products = productById(listProductsRes.products);
      this.loadProductItems();

      AppModule.StopProgress();
    } catch (err) {
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Ticket'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private loadProductItems() {
    this.productItems = [];
    this.products.forEach(p => {
      if ((p.type as ProductTypeEnum) !== ProductTypeEnum.FREE_MATERIAL) {
        this.productItems.push({
          text: `[${this.$t(
            'ProductTypeEnum.' + p.type
          )}] ${this.getProductName(p)}`,
          value: p.id,
        });
      }
    });
  }

  private handleSearch() {
    const req = {
      ticketNumber: this.ticketNumber,
    } as look_up_ticket_number.Request;
    if (this.productId) {
      req.productId = this.productId;
    }
    this.$emit(TicketSearchForm.ticketSearchFormSearchEvent, req);
  }

  private getProductName(product: list_product_summaries.Product) {
    return `${
      this.$i18n.locale !== 'ja' && this.products.get(product.id)!.nameEn
        ? this.products.get(product.id)!.nameEn
        : this.products.get(product.id)!.name
    }${
      this.products.get(product.id)!.fiscalYear === 0
        ? ''
        : ' [' + this.products.get(product.id)!.fiscalYear + ']'
    }`;
  }
}
